import * as React from "react";
import { Modal,Button,Input} from "antd";
import { connect } from "react-redux";
const { TextArea } = Input;

interface IUnsubscribeProps {
  id:any;
  unsubscribe:any;
  label: any;
  style: any;
  status:any;
  getOrderDetails:any;
}

// 确认函
class Unsubscribe extends React.Component<IUnsubscribeProps, any> {
  state = {
    visible:false,
    content:'',
  };
  constructor(props: IUnsubscribeProps) {
    super(props);
  }

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  }
  
  show(id) {
    this.setState({
      visible:true
    })
  }

  onChange =(value) => {
    this.setState({
      content:value.target.value
    })     
  }
  
  submit = () =>{
    const param: any = {
      id: this.props.id,
      order_status:this.props.status,
      content:this.state.content,
    }; 
    this.props.unsubscribe({
      ...param,
      callback: (data) => {
        if(data.res.code != 1001){
          this.handleCancel();
          const params: any = {
            id: this.props.id
          }; 
          this.props.getOrderDetails({
             ...params,
             callback: () => {
             }
           });
         }
      }
     }); 
  }


  render() {
    return (
      <React.Fragment>
      <Button type="primary" style={{...this.props.style,paddingLeft: "28",paddingRight: "28", backgroundColor: "#2b9fbd" }}  onClick={this.show.bind(this,this.props.id)}><div>{this.props.label}</div></Button> 
      <Modal onCancel={this.handleCancel} onOk={this.submit} title="退订原因"  visible={this.state.visible}  width="auto" centered={true}>
          <div className="abnormal">
              <TextArea placeholder="退订原因" value={this.state.content} onChange={this.onChange}  rows={5} />
          </div>
      </Modal> 
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
  status: state.orderDetails.status,
});

const mapDispatch = dispatch => {
  return {
    sendMail:dispatch.orderDetails.sendMail,
    unsubscribe:dispatch.orderDetails.unsubscribe,
    getOrderDetails:dispatch.orderDetails.getOrderDetails,
  };
};

export default connect(
  mapState ,
  mapDispatch
)(Unsubscribe);
